/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemHeartWrapper_item = {
    readonly serviceId: string | null;
    readonly heartPortfolioItems?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"Heart_heartPortfolioItems">;
    } | null> | null;
    readonly " $refType": "ItemHeartWrapper_item";
};
export type ItemHeartWrapper_item$data = ItemHeartWrapper_item;
export type ItemHeartWrapper_item$key = {
    readonly " $data"?: ItemHeartWrapper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemHeartWrapper_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "loadPortfolioData"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemHeartWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "condition": "loadPortfolioData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "heartPortfolioItems",
          "args": [
            {
              "kind": "Literal",
              "name": "portfolioType",
              "value": "HEART"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "PortfolioItemV2",
          "kind": "LinkedField",
          "name": "portfolioItems",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Heart_heartPortfolioItems"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '3cc9f9f07351654ffe5a68f9eb6b5ae3';
export default node;
